import React from "react";
import { TextField, Box } from "@mui/material";
import { getFieldLabel } from "../../constants/Helpers";
import HelpText from "../HelpText/HelpText";

function NumTrapsInWater({ numTrapsInWater, handleChange }) {
  return (
    <Box m={0} width="100%" align="center">
      <h2 className="sectionTitle center">
        {getFieldLabel("effort", "numTrapsInWater")}
      </h2>
      <TextField
        name="numTrapsInWater"
        variant="standard"
        inputProps={{
          min: 1,
          style: { textAlign: "center" },
        }}
        size="small"
        type="number"
        value={numTrapsInWater}
        onChange={handleChange}
      />
      <HelpText
        helpText={getFieldLabel("effort", "numTrapsInWater", "helptext")}
      />
    </Box>
  );
}

export default NumTrapsInWater;
